<template>
  <div class="info">
     <div class="details">
         <ul>
           <li><p>Full name</p><strong>{{this.$store.state.user_info.full_name}}</strong></li>
           <li><p>Emall</p><strong>{{this.$store.state.user_info.email}}</strong> <span style="color:#999;padding-left:20px">is the login</span></li>
           <li><p>Phone number</p><strong>{{this.$store.state.user_info.phone}}</strong></li>
           <li><p>Date of Birth</p><strong>{{this.$store.state.user_info.birth_date}}</strong></li>
         </ul>
     </div>
     <div class="address">
        <div class="title">Address</div>
        <ul>
           <li><p>Country of Residence</p><strong>{{this.$store.state.user_info.residence_country}}</strong></li>
           <li><p>House Name / Number</p><strong>{{this.$store.state.user_info.house_name}}</strong></li>
           <li><p>Street Name</p><strong>{{this.$store.state.user_info.street_name}}</strong></li>
           <li><p>City</p><strong>{{this.$store.state.user_info.city}}</strong></li>
           <li><p>County / State</p><strong>{{this.$store.state.user_info.state}}</strong></li>
           <li><p>Postcode / Zip</p><strong>{{this.$store.state.user_info.zip_code}}</strong></li>
         </ul>
     </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      homeHostName: '',
      steps: 1,
      status: 1
    }
  },
  created() {},
  methods: {},
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.info {
  .details {
    > ul {
      > li {
        p {
          display: inline-block;
          font-size: 14px;
          line-height: 35px;
          width: 150px;
          color: #888888;
        }
        strong {
          display: inline-block;
          font-size: 14px;
          line-height: 35px;
          letter-spacing: 0px;
          color: #444444;
        }
      }
    }
  }
  .address {
    .title {
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      margin-top: 45px;
      line-height: 25px;
      letter-spacing: 0px;
      color: #323232;
      margin-bottom: 20px;
    }
    > ul {
      background-color: #f5f5f5;
      padding: 30px 35px;
      > li {
        p {
          display: inline-block;
          font-size: 14px;
          line-height: 35px;
          width: 160px;
          color: #888888;
        }
        strong {
          display: inline-block;
          font-size: 14px;
          line-height: 35px;
          letter-spacing: 0px;
          color: #444444;
        }
      }
    }
  }
}
</style>
